﻿'use strict';

angular.module('ntmApp')
  .directive('calendarFilters', function () {
      return {
          restrict: 'E',
          templateUrl: 'ng1/src/calendar/directives/calendarFilters.html',
          scope: {
              filtersData: '='
          }
      };
  });